import { NodeLayer } from "@/Utils/Collections";

export enum Layer {
  Portfolio = "customer",
  Brand = "brand",
  Category = "category",
  Product = "product",
  Unknown = "unknown",
}

export enum FunnelTotal {
  Total = "total",
}

export type FunnelType = FunnelTotal | Layer;

export const Funnel = {
  ...FunnelTotal,
  ...Layer,
};

export type BCPLayer = Layer.Brand | Layer.Category | Layer.Product;

export const LAYER_ORDER = [Layer.Portfolio, Layer.Brand, Layer.Category, Layer.Product];

const MAP_LAYER_TO_NODE_LAYER = {
  [Layer.Portfolio]: "customer",
  [Layer.Brand]: "brand",
  [Layer.Category]: "category",
  [Layer.Product]: "product",
  [Layer.Unknown]: "unknown",
};

export const LAYER_TO_DISPLAY_NAME: { [key in Layer]: string } = {
  customer: "portfolio",
  brand: "brand",
  category: "category",
  product: "product",
  unknown: "unknown",
};

const layerToNodeLayer = (layer: Layer): NodeLayer => {
  return MAP_LAYER_TO_NODE_LAYER[layer];
};

const LAYER_PLACEHOLDER = "${layer}";

export const layerToDisplayName = (availableLayers: NodeLayer[], layer: Layer): string => {
  // Treat portfolio/customer layer as brand when there is no brand layer
  if (layer === Layer.Portfolio && !availableLayers.includes(Layer.Brand)) {
    return LAYER_TO_DISPLAY_NAME[Layer.Brand];
  }
  return LAYER_TO_DISPLAY_NAME[layer];
};

export const compareLayers = (a: Layer, b: Layer) => {
  return LAYER_ORDER.indexOf(a) - LAYER_ORDER.indexOf(b);
};

export const getLayer = (nodeLayer: string[]): Layer => {
  return LAYER_ORDER[nodeLayer.length - 1] || Layer.Unknown;
};

// TODO: May need to account for mapping here
export const getDescendants = (layer: Layer, availableLayers: NodeLayer[]): Layer[] => {
  const layerIndex = LAYER_ORDER.indexOf(layer);
  return LAYER_ORDER.slice(layerIndex + 1).filter((layer) =>
    availableLayers.includes(layerToNodeLayer(layer))
  );
};

export const getAncestors = (layer: Layer, availableLayers: NodeLayer[]): Layer[] => {
  const layerIndex = LAYER_ORDER.indexOf(layer);
  return LAYER_ORDER.slice(0, layerIndex).filter((layer) =>
    availableLayers.includes(layerToNodeLayer(layer))
  );
};

export const getLabelForLayer = (
  label: string,
  availableLayers: NodeLayer[],
  layer: Layer
): string => {
  return label.replace(LAYER_PLACEHOLDER, layerToDisplayName(availableLayers, layer));
};

export const getFilteredLayer = (availableLayers: NodeLayer[], layer: Layer): Layer => {
  // Treat portfolio/customer layer as brand when there is no brand layer
  if (layer === Layer.Portfolio && !availableLayers.includes("brand" as NodeLayer)) {
    return Layer.Brand;
  }
  return layer;
};

export const replaceLayerPlaceholder = (
  layerObject: any,
  templateObject: { [key: string]: string }
) => {
  const result: { [key: string]: string } = {};

  for (const [key, value] of Object.entries(templateObject)) {
    result[key] = value.replace(/\${layer}/g, String(layerObject));
  }

  return result;
};
